import * as servicesActions from '../actions/services';

const initialState = {
    isLoading: false,
    services: [],
    userServices: [],
    serviceReferrer: null,
    selectedCountryCode: null
};

export default (state = initialState, action) => {
    switch (action.type) {

        case servicesActions.REFRESH_ALL_SERVICES_REQUESTED:
            return {
                ...state,
                isLoading: true
            };

        case servicesActions.REFRESH_ALL_SERVICES_RECEIVED:
            return {
                ...state,
                services: action.services,
                isLoading: false
            };

        case servicesActions.REFRESH_USER_SERVICES_RECEIVED:
            return {
                ...state,
                userServices: action.services
            };

        case servicesActions.SERVICE_REFERRER_RECEIVED:
            return {
                ...state,
                serviceReferrer: action.service
            };

        case servicesActions.SERVICE_COUNTRY_CODE_CHANGED:
            return {
                ...state,
                selectedCountryCode: action.countryCode
            };

        default:
            return state;
    }
};